module.exports = __webpack_public_path__ + "static/media/client-area.99a0535c.svg";